module.exports = __webpack_public_path__ + "static/media/logo-davinopolis.95820d07.png";